// extracted by css-extract-rspack-plugin
export default {"inlineCodeTitle":"TitleInlineCode-module__inlineCodeTitle__yr9qP"};